import { render, staticRenderFns } from "./ModalNovaSenha.vue?vue&type=template&id=7fa18aa0&"
import script from "./ModalNovaSenha.vue?vue&type=script&lang=js&"
export * from "./ModalNovaSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports